import { useState, useEffect } from 'react';
import { POST_MESSAGE_TYPES } from '../constants';

/**
 * Manages documents panel visibility and postMessage communication with iframe.
 * Panel opens/closes ONLY when the documents button is clicked (or programmatic .click()).
 * When the button is hidden, the panel is always closed.
 */
export function useDocumentsPanel() {
  const [showPanel, setShowPanel] = useState(false);
  const [showButton, setShowButton] = useState(false);

  // When button is hidden, panel must also be closed
  useEffect(() => {
    if (!showButton) {
      setShowPanel(false);
    }
  }, [showButton]);

  useEffect(() => {
    const handleMessage = (event) => {
      switch (event.data?.type) {
        case POST_MESSAGE_TYPES.SHOW_DOCUMENTS_BUTTON:
          setShowButton(true);
          break;
        case POST_MESSAGE_TYPES.HIDE_DOCUMENTS_BUTTON:
          setShowButton(false);
          setShowPanel(false);
          break;
        case POST_MESSAGE_TYPES.SHOW_DOCUMENTS_PANEL:
          setShowButton(true);
          // Open panel only via button click (trigger the button)
          setTimeout(() => document.getElementById('documents-button')?.click(), 0);
          break;
        case POST_MESSAGE_TYPES.HIDE_DOCUMENTS_PANEL:
          setShowPanel(false);
          break;
        case POST_MESSAGE_TYPES.TOGGLE_DOCUMENTS_PANEL:
          setShowButton(true);
          // Toggle panel only via button click (trigger the button)
          setTimeout(() => document.getElementById('documents-button')?.click(), 0);
          break;
        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (!showPanel) return;

    const handleClickOutside = (event) => {
      const panel = document.getElementById('documents-dropdown-panel');
      const button = document.getElementById('documents-button');
      if (panel && button && !panel.contains(event.target) && !button.contains(event.target)) {
        setShowPanel(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPanel]);

  // Only the documents button onClick should call this – panel opens/closes only on button click
  const togglePanel = () => setShowPanel((prev) => !prev);

  return { showPanel, showButton, setShowPanel, togglePanel };
}
